import React from "react";
import { defaultStyle } from "./style";
import { css } from "emotion";
import { Select as AtomicSelect } from "@maxmilhas/hangar-components-atomic/public";

const Select = props => {
    const selectStyle = defaultStyle(props.hasError, props.shadow);
    return (
        <div
            className={css`
				${selectStyle}
			`}
        >
            <AtomicSelect {...props} />
        </div>
    );
};
export default Select;